import React, { useState } from 'react'
import * as routeLink from "../../constants/routeLink";

import CardShopDog from "../../components/CardShopDog/index";
import ProcessBar from "../../components/ProcessBar/index";

import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { addressDeposit } from '../../services/services';
import { toast } from 'react-toastify';
const Deposits = (props) => {
  const { apiReducer } = useSelector((state) => state);
  const { user } = apiReducer;
  const navigate = useNavigate();
  const onclickChangePage = (path) => {
    navigate(path);
  }


  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>


      <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2'>

        <div className='d-flex w-100 flex-column justify-content-center align-items-center'>
          <h4 className='w-100 text-white justify-content-center align-items-center fs-extra d-flex m-0 mx-2'>Deposit</h4>
          <div className='col-sm-12 col-md-12 col-lg-12   col-12'>
            <div style={{ padding: '20px', color: '#fff' }}>
              <div className='lllsladowods'>Network</div>
              <div>
                <b>TON</b> (TON)
              </div>
              <div style={{ height: '20px' }}></div>
              <div className="img_" style={{ maxWidth: '300px', margin: 'auto', textAlign: 'center' }}>
                <img
                  src={`https://quickchart.io/qr?text=${addressDeposit}&size=360`}
                  alt=""
                  style={{ width: '80%', height: '80%' }}
                />
              </div>
              <div style={{ height: '20px' }}></div>
              <div className='mb-2 lllsladowods'>Deposit address</div>
              <div style={{ overflowWrap: 'break-word', marginBottom: 8 }} onClick={() => {
                navigator.clipboard.writeText(addressDeposit).then(() => {
                  toast('Text copied to clipboard!');
                }).catch((err) => {
                  console.error('Failed to copy text: ', err);
                });
              }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 25 25"
                  fill="#0052ff"
                  style={{ marginBottom: '5px', marginLeft: '5px' }}
                >
                  <path d="M16.5 13.094v4.2c0 3.5-1.4 4.9-4.9 4.9H7.4c-3.5 0-4.9-1.4-4.9-4.9v-4.2c0-3.5 1.4-4.9 4.9-4.9h4.2c3.5 0 4.9 1.4 4.9 4.9z"></path>
                  <path
                    opacity="0.4"
                    d="M17.6 2.194h-4.2c-3.45 0-4.85 1.37-4.89 4.75h3.09c4.2 0 6.15 1.95 6.15 6.15v3.09c3.38-.04 4.75-1.44 4.75-4.89v-4.2c0-3.5-1.4-4.9-4.9-4.9z"
                  ></path>
                </svg>
                <span>{addressDeposit}</span>
              </div>

              <div className='mb-2 lllsladowods'>Comment</div>
              <div style={{ overflowWrap: 'break-word', marginBottom: 8 }} onClick={() => {
                navigator.clipboard.writeText(user?.userID?.replaceAll("user", '')).then(() => {
                  toast('Text copied to clipboard!');
                }).catch((err) => {
                  console.error('Failed to copy text: ', err);
                });
              }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 25 25"
                  fill="#0052ff"
                  style={{ marginBottom: '5px', marginLeft: '5px' }}
                >
                  <path d="M16.5 13.094v4.2c0 3.5-1.4 4.9-4.9 4.9H7.4c-3.5 0-4.9-1.4-4.9-4.9v-4.2c0-3.5 1.4-4.9 4.9-4.9h4.2c3.5 0 4.9 1.4 4.9 4.9z"></path>
                  <path
                    opacity="0.4"
                    d="M17.6 2.194h-4.2c-3.45 0-4.85 1.37-4.89 4.75h3.09c4.2 0 6.15 1.95 6.15 6.15v3.09c3.38-.04 4.75-1.44 4.75-4.89v-4.2c0-3.5-1.4-4.9-4.9-4.9z"
                  ></path>
                </svg>
                <span>{user?.userID?.replaceAll("user", '')}</span>
              </div>

              <div style={{ height: '20px' }}></div>
              <div>⚠️ IMPORTANT WARNING: You must copy both the NOT address and the comment to ensure a successful deposit. If either is missing, your assets will be lost!</div>
            </div>
          </div>
        </div>
      </div>
      <div className='ksakdksadkoogeasds'></div>
    </div>
  )
}

export default Deposits;
